<template>
  <div class="tip-wrapper">
    <div 
      :v-show="show"
      class="tip"
      :class="{'bottom-tip': tipType==='bottom'}"
      v-for="(item, index) in tick"
      :key="index"
      >
      {{item.title}}
      <span
        :style="{'color': item.color}"
        :class="item.className">
        {{item.value}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tick: {
      type: Array,
      default: function() {
        return []
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    tipType: {
      type: String,
      default: 'sub'
    }
  }
}
</script>
<style scoped>
  .tip-wrapper{
    display: flex;
    align-items: center;
    color: #8C9295;
    font-size: .1rem
  }
  .tip {
    margin-right: .24rem
  }
  .bottom-tip {
    margin-right: 0.08rem;
  }
</style>
